/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Agbw_ResultsInputs */

const en_page_title_agbw_results = /** @type {(inputs: Page_Title_Agbw_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGBW results`)
};

const nl_page_title_agbw_results = /** @type {(inputs: Page_Title_Agbw_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGBW-resultaten`)
};

/**
* | output |
* | --- |
* | "AGBW results" |
*
* @param {Page_Title_Agbw_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_agbw_results = /** @type {((inputs?: Page_Title_Agbw_ResultsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Agbw_ResultsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_agbw_results(inputs)
	return en_page_title_agbw_results(inputs)
});